/* NB: 商品ページの追従カートボタン（2026-10 追加）
 * 元のカートボタンが画面外のときだけ画面下にバーを出し、状態（未選択・売り切れ・価格・サイズ名）を元のフォームと同期する。
 * カート追加そのものは元のボタンを click() させる＝テーマ・アプリの既存処理を通す。 */
(function () {
  var PLACEHOLDER_ATTR = 'data-placeholder-set'; // variant-placeholder.js が付ける属性

  function init() {
    var bar = document.querySelector('[data-nb-sticky-cart]');
    if (!bar) return;

    var form = document.querySelector('.Product__Info form.ProductForm') || document.querySelector('form.ProductForm');
    if (!form) return;
    var orig = form.querySelector('.ProductForm__AddToCart');
    var buyWrap = form.querySelector('.ProductForm__BuyButtons') || orig;
    if (!orig || !buyWrap) return;

    var barBtn = bar.querySelector('[data-nb-sticky-button]');
    var optBtn = bar.querySelector('[data-nb-sticky-option]');
    var priceEl = bar.querySelector('[data-nb-sticky-price]');
    var selectLabel = bar.getAttribute('data-select-label');
    var btnLabel = barBtn.textContent;
    // 未選択時の価格（「〜円から」）。variant-placeholder.js より先に同期が走って価格を書き換えても、未選択に戻ったら元に戻す
    var initialPrice = priceEl ? priceEl.textContent.trim() : '';
    var soldOutLabel = bar.getAttribute('data-sold-out-label') || '';
    // 全バリアント売り切れの商品は、サイズ未選択でも最初から「売り切れ」にする
    var allSoldOut = bar.getAttribute('data-all-sold-out') === 'true';

    // サイズ名の「(商品コード：11316)」部分はバーでは省く
    function cleanValue(v) {
      return v.replace(/[\s　]*[（(]\s*商品コード[^）)]*[）)]/g, '').trim();
    }

    // variant-placeholder.js の判定に合わせる：プレースホルダー文言のままの項目があれば未選択
    function isUnselected() {
      var items = form.querySelectorAll('.ProductForm__Item[' + PLACEHOLDER_ATTR + ']');
      for (var i = 0; i < items.length; i++) {
        var sel = items[i].querySelector('.ProductForm__SelectedValue');
        if (sel && sel.textContent.trim() === items[i].getAttribute(PLACEHOLDER_ATTR)) return true;
      }
      return false;
    }

    function selectedText() {
      var vals = [];
      form.querySelectorAll('.ProductForm__SelectedValue').forEach(function (el) {
        var t = cleanValue(el.textContent || '');
        if (t) vals.push(t);
      });
      return vals.join(' / ');
    }

    function sync() {
      var unselected = isUnselected();
      var soldOut = allSoldOut || (!unselected && orig.disabled);

      if (optBtn) optBtn.textContent = unselected ? selectLabel : (selectedText() || selectLabel);

      if (priceEl) {
        var p = form.querySelector('.ProductMeta__Price:not(.Price--compareAt)') || document.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
        if (unselected) priceEl.textContent = initialPrice;
        else if (p && p.textContent.trim()) priceEl.textContent = p.textContent.trim();
      }

      bar.classList.toggle('is-unselected', unselected && !allSoldOut);
      bar.classList.toggle('is-sold-out', soldOut);
      barBtn.disabled = soldOut;
      barBtn.textContent = soldOut ? (soldOutLabel || orig.textContent.trim() || btnLabel) : btnLabel;
    }

    // サイズ選択の位置へ移動（ヘッダー分ずらす）。
    // 途中で画像の遅延読込などによりページの高さが変わると、なめらかスクロールが目標からずれて止まることがあるため、
    // 移動後に位置を測り直し、ずれていれば合わせ直す。
    function optionsTop() {
      var target = form.querySelector('.ProductForm__Variants') || form;
      var header = document.querySelector('.Header__Wrapper, .shopify-section--header');
      var offset = header ? header.getBoundingClientRect().height + 16 : 80;
      return target.getBoundingClientRect().top + window.pageYOffset - offset;
    }
    var fixTimer = null;
    function goToOptions() {
      window.scrollTo({ top: optionsTop(), behavior: 'smooth' });
      window.clearTimeout(fixTimer);
      var tries = 0;
      (function verify() {
        fixTimer = window.setTimeout(function () {
          var top = optionsTop();
          if (Math.abs(window.pageYOffset - top) > 10) {
            // まだ動いている途中なら待つ。止まっていれば位置を合わせ直す
            var before = window.pageYOffset;
            window.setTimeout(function () {
              if (Math.abs(window.pageYOffset - before) < 2) window.scrollTo({ top: optionsTop(), behavior: 'auto' });
              if (++tries < 3) verify();
            }, 150);
          }
        }, 700);
      })();
    }

    barBtn.addEventListener('click', function () {
      if (barBtn.disabled) return;
      if (isUnselected()) { goToOptions(); return; }
      orig.click();
    });
    if (optBtn) optBtn.addEventListener('click', goToOptions);

    // 表示切替：元のボタンが画面に見えている間は隠す
    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      barBtn.tabIndex = v ? 0 : -1;
      if (optBtn) optBtn.tabIndex = v ? 0 : -1;
      // PCで非表示設定のときは余白も足さない
      document.documentElement.classList.toggle('nb-sticky-cart-on', v && window.getComputedStyle(bar).display !== 'none');
    }
    // 元のボタンの位置を直接測って判定する。IntersectionObserver の通知だけだと取りこぼすことがあるため、
    // スクロール・リサイズ・選択変更のたびにその場で測る（getBoundingClientRect 1回なので負荷は小さい）
    var current = null;
    function checkVisibility() {
      var r = buyWrap.getBoundingClientRect();
      var inView = r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
      if (current !== !inView) { current = !inView; setVisible(current); }
    }
    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility);
    document.addEventListener('scroll', checkVisibility, { passive: true, capture: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(checkVisibility).observe(buyWrap);
    checkVisibility();

    // 状態の同期：テーマのバリアント変更イベント＋元ボタン／選択値の変化を監視
    document.addEventListener('variant:changed', function () { window.requestAnimationFrame(sync); });
    var mo = new MutationObserver(function () { sync(); checkVisibility(); });
    mo.observe(orig, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    form.querySelectorAll('.ProductForm__SelectedValue').forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true, characterData: true });
    });

    // variant-placeholder.js（DOMContentLoaded で初期化）の後に初回同期
    window.setTimeout(sync, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
